import { render, staticRenderFns } from "./NavbarBurgerMenu.vue?vue&type=template&id=bf181b40&scoped=true&"
import script from "./NavbarBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./NavbarBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBurgerMenu.vue?vue&type=style&index=0&id=bf181b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf181b40",
  null
  
)

export default component.exports